/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technologies_Unresolved_AmbiguousInputs */

const en_us2_technologies_unresolved_ambiguous = /** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This identifier can refer to multiple technologies, so we are not publishing a guessed profile.`)
};

const es_es2_technologies_unresolved_ambiguous = /** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este identificador puede referirse a varias tecnologías, así que no publicaremos un perfil basado en suposiciones.`)
};

const ru_technologies_unresolved_ambiguous = /** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот идентификатор может относиться к нескольким технологиям, поэтому мы не публикуем его предполагаемый профиль.`)
};

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const id_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const ms_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const da_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const de_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const es_mx2_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const fil_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const fr_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const it_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const hu_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const nl_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const no_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const pl_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const pt_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const pt_br2_technologies_unresolved_ambiguous = pt_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const ro_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const fi_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const sv_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const vi_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const tr_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const cs_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const bg_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const uk_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const ar_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const hi_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const th_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const ja_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const zh_cn2_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const zh_hant1_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/** @type {(inputs: Technologies_Unresolved_AmbiguousInputs) => LocalizedString} */
const ko_technologies_unresolved_ambiguous = en_us2_technologies_unresolved_ambiguous;

/**
* | output |
* | --- |
* | "This identifier can refer to multiple technologies, so we are not publishing a guessed profile." |
*
* @param {Technologies_Unresolved_AmbiguousInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_unresolved_ambiguous = /** @type {((inputs?: Technologies_Unresolved_AmbiguousInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_Unresolved_AmbiguousInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_unresolved_ambiguous(inputs)
	if (locale === "ms") return ms_technologies_unresolved_ambiguous(inputs)
	if (locale === "da") return da_technologies_unresolved_ambiguous(inputs)
	if (locale === "de") return de_technologies_unresolved_ambiguous(inputs)
	if (locale === "en-US") return en_us2_technologies_unresolved_ambiguous(inputs)
	if (locale === "es-ES") return es_es2_technologies_unresolved_ambiguous(inputs)
	if (locale === "es-MX") return es_mx2_technologies_unresolved_ambiguous(inputs)
	if (locale === "fil") return fil_technologies_unresolved_ambiguous(inputs)
	if (locale === "fr") return fr_technologies_unresolved_ambiguous(inputs)
	if (locale === "it") return it_technologies_unresolved_ambiguous(inputs)
	if (locale === "hu") return hu_technologies_unresolved_ambiguous(inputs)
	if (locale === "nl") return nl_technologies_unresolved_ambiguous(inputs)
	if (locale === "no") return no_technologies_unresolved_ambiguous(inputs)
	if (locale === "pl") return pl_technologies_unresolved_ambiguous(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_unresolved_ambiguous(inputs)
	if (locale === "pt") return pt_technologies_unresolved_ambiguous(inputs)
	if (locale === "ro") return ro_technologies_unresolved_ambiguous(inputs)
	if (locale === "fi") return fi_technologies_unresolved_ambiguous(inputs)
	if (locale === "sv") return sv_technologies_unresolved_ambiguous(inputs)
	if (locale === "vi") return vi_technologies_unresolved_ambiguous(inputs)
	if (locale === "tr") return tr_technologies_unresolved_ambiguous(inputs)
	if (locale === "cs") return cs_technologies_unresolved_ambiguous(inputs)
	if (locale === "bg") return bg_technologies_unresolved_ambiguous(inputs)
	if (locale === "ru") return ru_technologies_unresolved_ambiguous(inputs)
	if (locale === "uk") return uk_technologies_unresolved_ambiguous(inputs)
	if (locale === "ar") return ar_technologies_unresolved_ambiguous(inputs)
	if (locale === "hi") return hi_technologies_unresolved_ambiguous(inputs)
	if (locale === "th") return th_technologies_unresolved_ambiguous(inputs)
	if (locale === "ja") return ja_technologies_unresolved_ambiguous(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_unresolved_ambiguous(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_unresolved_ambiguous(inputs)
	return ko_technologies_unresolved_ambiguous(inputs)
});
export { technologies_unresolved_ambiguous as "technologies.unresolved.ambiguous" }